import { render, staticRenderFns } from "./setButton.vue?vue&type=template&id=d2a55516&scoped=true"
import script from "./setButton.vue?vue&type=script&lang=js"
export * from "./setButton.vue?vue&type=script&lang=js"
import style0 from "./setButton.vue?vue&type=style&index=0&id=d2a55516&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a55516",
  null
  
)

export default component.exports